// @flow
import { connect } from 'react-redux';
import ListHeadComponent from './ListHead';

const ListHeadContainer = connect()(ListHeadComponent);

ListHeadContainer.displayName = 'ListHeadContainer';

export default ListHeadContainer;



// WEBPACK FOOTER //
// ./app/Serp/components/ListHead/ListHeadContainer.js